import { ref, type Ref } from 'vue'
import { usePrevioDS } from '@previo/design-system'
import { useAPI } from '~/http'
import { goToPrevioIDLogout } from '~/composables/PrevioID'
import { useAuthenticationStore } from '~/store/authentication'
import { usePushNotifications } from '~/plugins/pushNotifications'

type UseLogout = {
  isDoingLogout: Ref<boolean>
  logout: () => Promise<void>
}

export const useLogout = (): UseLogout => {
  const ds = usePrevioDS()
  const pushNotificationsClient = usePushNotifications().instance
  const { authApi } = useAPI()
  const isDoingLogout = ref<boolean>(false)

  const logout = async (): Promise<void> => {
    isDoingLogout.value = true

    await pushNotificationsClient?.deactivate()

    return authApi
      .logout()
      .then(() => {
        useAuthenticationStore.value = {
          accessToken: '',
          refreshToken: '',
        }

        goToPrevioIDLogout()
      })
      .catch((error) => {
        ds.toast.error(error)
      })
      .finally(() => {
        isDoingLogout.value = false
      })
  }

  return { isDoingLogout, logout }
}
